export { default } from './FeatureSlider';
